export default {
      id: "post-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#post",
      toString: function () {
        return this.url;
      }
    }